import { render, staticRenderFns } from "./MoreOrdersList.vue?vue&type=template&id=2d95f494&scoped=true&"
import script from "./MoreOrdersList.vue?vue&type=script&lang=js&"
export * from "./MoreOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./MoreOrdersList.vue?vue&type=style&index=0&id=2d95f494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95f494",
  null
  
)

export default component.exports